import { create } from 'zustand';

const useInventoryViewStore = create((set) => ({
  actualShowPriceLabel: false,
  requestShowPriceLabel: null,

  toggleShowPriceLabel: () =>
    set((state) => ({
      actualShowPriceLabel: !state.actualShowPriceLabel,
      requestShowPriceLabel: !state.actualShowPriceLabel,
    })),

  setActualShowPriceLabel: (value) =>
    set({
      actualShowPriceLabel: value,
      requestShowPriceLabel: value,
    }),

  clearRequestShowPriceLabel: () =>
    set({ requestShowPriceLabel: null }),
}));

export default useInventoryViewStore;